import axiosInstance from "../axiosInstance";
import { encryptRequestData } from "../../js/helper"
const apigeeDomain = process.env.REACT_APP_APIGEE_API_DM;

const postQR = (inputData) => {
    const headers = {
        headers: encryptRequestData(inputData)
    };
    const URL = apigeeDomain + process.env.REACT_APP_API_VIP_QR;
    return axiosInstance.post(URL, inputData, headers)
}

const getVipLoanStatus = (inputData) => {
    const URL = apigeeDomain + process.env.REACT_APP_API_VIP_STATUS;
    return axiosInstance.get(URL, { params: inputData })
}

const getVipOfferDetails = (inputData) => {
    const headers = {
        headers: encryptRequestData(inputData)
    };
    const URL = apigeeDomain + process.env.REACT_APP_API_VIP_OFFER;
    return axiosInstance.post(URL, inputData, headers)
}

const postVipLoanCompletion = (inputData) => {
    const headers = {
        headers: encryptRequestData(inputData)
    };
    const URL = apigeeDomain + process.env.REACT_APP_API_VIP_COMPLETION;
    return axiosInstance.post(URL, inputData, headers)
}


export { postQR, getVipLoanStatus, getVipOfferDetails, postVipLoanCompletion };